// extracted by mini-css-extract-plugin
module.exports = {"svg_wrapper":"BackTitle_svg_wrapper__QGi4S","back_title_wrapper":"BackTitle_back_title_wrapper__UgGj_"};